<template>
    <div class="bkr-cc">
        <div class="input-group">
          <input
            type="search"
            class="search-input flex-grow-1 px-2 py-2 bkmSearchbox"
            id="bk-searchbox-1"
            ref="searchInput"
            enterkeyhint="search"
            v-model="searchString"
            @input="onValueChanged($event.target.value)"
            @keyup.enter="search()"
            @focus="isSearchFocused = true"
            @blur="onBlurSearchField($event)"
            :autofocus="isShopBuilder"
            :aria-label="$translate('Ceres::Template.headerSearchTerm')"
            placeholder="Suchbegriff eingeben..." />
            <button class="clearField" v-if="searchString.length" type="button" @click="clearInput()">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
            </button>
            <span class="input-group-append d-none">
              <button class="search-submit btn btn-bkm bkmSearchbutton" aria-label="Suchen" type="submit" @click="search()">
                <icon class="fa-fw" icon="search" :loading="autocompleteIsLoading"></icon>
              </button>
            </span>
        </div><!-- 

  --><template v-if="isSearchFocused">
        <div v-show="(searchString.length >= searchMinLength && hasInitialInput) || $ceres.isShopBuilder || isSearchFocused">
            <slot name="autocomplete-suggestions">
              <div class="autocomplete-results bg-white">
                    <search-suggestion-item :is-loading="autocompleteIsLoading" padding-classes="px-2" :show-images="false" suggestion-type="suggestion" :show-additional-information="true" :show-count="false"></search-suggestion-item>

                    <search-suggestion-item :is-loading="autocompleteIsLoading" padding-classes="px-2" :show-images="true" suggestion-type="item" :show-additional-information="false" :show-count="false"></search-suggestion-item>

                    <search-suggestion-item :is-loading="autocompleteIsLoading" padding-classes="px-2" :show-images="false" suggestion-type="category" :show-additional-information="true" :show-count="false"></search-suggestion-item>

                    <search-suggestion-item :is-loading="autocompleteIsLoading" padding-classes="px-2" :show-images="true" suggestion-type="brands" :show-additional-information="true" :show-count="false"></search-suggestion-item>
              </div>
            </slot>
          </div>
    </template>
</div>
</template>

<script>
import UrlService from "../../services/UrlService";
import { isNullOrUndefined, defaultValue } from "../../helper/utils";
import { pathnameEquals } from "../../helper/url";
import { mapState } from 'vuex';
import { debounce } from '../../helper/debounce';

export default {

    name: "item-search",

    props: {
        showItemImages:
        {
            type: Boolean
        },
        forwardToSingleItem:
        {
            type: Boolean,
            default: App.config.search.forwardToSingleItem
        },
        timeout:
        {
            type: Number,
            default: 200
        },
        searchMinLength:
        {
            type: Number,
            default: 2
        }
    },

    data()
    {
        return {
            isSearchFocused: App.isShopBuilder,
            onValueChanged: null,
            searchString: "",
            hasInitialInput: false
        };
    },

    computed:
    {
        hasAutocompleteResults()
        {
            const item       = this.autocompleteResult.item;
            const category   = this.autocompleteResult.category;
            const suggestion = this.autocompleteResult.suggestion;

            return App.isShopBuilder || (item && item.length) || (category && category.length) || (suggestion && suggestion.length);
        },

        isShopBuilder()
        {
            return App.isShopBuilder;
        },

        ...mapState({
            autocompleteResult: state => state.itemSearch.autocompleteResult,
            moduleSearchString: state => state.itemList.searchString,
            autocompleteIsLoading: state => state.itemSearch.autocompleteIsLoading
        })
    },

    mounted()
    {
        this.onValueChanged = debounce(searchString =>
        {
            this.autocomplete(searchString);
        }, defaultValue(this.timeout, 200));

        this.$nextTick(() =>
        {
            const urlParams = UrlService.getUrlParams(document.location.search);

            this.$store.commit("setItemListSearchString", urlParams.query);

            this.$refs.searchInput.value = !isNullOrUndefined(urlParams.query) ? urlParams.query : "";
        });
    },

    methods:
    {
        search()
        {
            if (this.$refs.searchInput.value.length)
            {
                if (pathnameEquals(App.urls.search))
                {
                    this.$store.dispatch("searchItems", this.$refs.searchInput.value);
                }
                else
                {
                    window.open(`${App.urls.search}?query=${ this.searchString }`, "_self", false);
                }
            }
        },

        autocomplete(searchString)
        {
            if (searchString.length >= this.searchMinLength)
            {
                this.$store.dispatch("loadItemSearchAutocomplete", searchString);
            }
            else
            {
                this.$store.commit("setAutocompleteResult", { item: [], category: [], suggestion: [] });

                // hide the autocomplete box
                this.hasInitialInput = false;
            }
        },

        // hide search, if targetElement of the blur event is not a child of components' root element
        onBlurSearchField(event)
        {
            const target = event.relatedTarget;

            if (isNullOrUndefined(target) || !isNullOrUndefined(target) && !this.$el.contains(target))
            {
                this.isSearchFocused = false;
            }
        },

        clearInput()
        {
            this.searchString = '';
            this.$nextTick(() => {
                this.$refs.searchInput.focus();
            });
        }
    },

    watch:
    {
        // set the current search string, after clicking on a suggestion
        moduleSearchString(newVal)
        {
            if (newVal && newVal.length)
            {
                this.searchString = newVal;
            }
        },

        autocompleteIsLoading(newVal, oldVal) {
            // when client was loading and has stopped now, the autocomplete box should be shown
            if (oldVal && !newVal) {
                this.hasInitialInput = true;
            }
        }
    }
}
</script>
